import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import Header from '../components/Header';
import { companyInfo } from '../data/mock';
import {
  CheckCircle2,
  Mail,
  Clock,
  Phone,
  ArrowRight,
  Home
} from 'lucide-react';

const JoinSuccess = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Header variant="default" />
      
      <section className="pt-32 pb-16 lg:pt-40 lg:pb-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="shadow-xl border-0 overflow-hidden">
            <div className="bg-brand-yellow py-8 text-center">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto shadow-lg">
                <CheckCircle2 className="w-10 h-10 text-brand-yellow" />
              </div>
            </div>
            
            <CardContent className="p-8 text-center">
              <h1 className="text-3xl font-bold text-brand-navy mb-4">
                Application Submitted!
              </h1>
              <p className="text-lg text-brand-slate mb-8">
                Thank you for your interest in joining our network of trusted tradespeople.
              </p>
              
              <div className="bg-brand-grey rounded-xl p-6 mb-8">
                <h2 className="font-semibold text-brand-navy mb-4">What happens next?</h2>
                <div className="space-y-4 text-left">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-brand-grey rounded-full flex items-center justify-center flex-shrink-0">
                      <Mail className="w-4 h-4 text-brand-yellow" />
                    </div>
                    <div>
                      <p className="font-medium text-brand-navy">Check your email</p>
                      <p className="text-sm text-brand-slate/80">
                        You'll receive a confirmation email with your application details.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-brand-grey rounded-full flex items-center justify-center flex-shrink-0">
                      <Clock className="w-4 h-4 text-brand-yellow" />
                    </div>
                    <div>
                      <p className="font-medium text-brand-navy">Review period</p>
                      <p className="text-sm text-brand-slate/80">
                        Our team will review your application within 2-3 working days.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-brand-grey rounded-full flex items-center justify-center flex-shrink-0">
                      <Phone className="w-4 h-4 text-brand-yellow" />
                    </div>
                    <div>
                      <p className="font-medium text-brand-navy">We'll be in touch</p>
                      <p className="text-sm text-brand-slate/80">
                        If your application is successful, we'll contact you to discuss next steps.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button asChild className="bg-brand-yellow hover:bg-yellow-300 text-brand-navy font-semibold">
                  <Link to="/" data-testid="btn-home">
                    <Home className="w-4 h-4 mr-2" />
                    Back to Home
                  </Link>
                </Button>
                <Button asChild variant="outline">
                  <a href={`mailto:${companyInfo.email}`} data-testid="btn-contact">
                    <Mail className="w-4 h-4 mr-2" />
                    Contact Us
                  </a>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default JoinSuccess;
